import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');
  const [menuOpen, setMenuOpen] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowServices(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
    setMenuOpen(false);
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);
  
  const closeMenu = () => {
    setMenuOpen(false);
    setShowServices(false);
  };

  const getActiveClass = ({ isActive }) => `nav-link ${isActive ? 'active-link' : ''}`;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        
        {/* Branding/Logo Area */}
        <NavLink to="/" className="navbar-logo-link" onClick={closeMenu}>
          <div className="logo-container">
            <img
              src="https://cwrvtzjlxapzlgqzwnfn.supabase.co/storage/v1/object/public/logos/Logo.png"
              alt="Apartment System Logo"
              className="logo-img"
            />
            <div className="brand-text-container">
              <span className="brand-name">GKM Invest</span>
              <span className="brand-subtext">Property Developer, Realtor and Services</span>
            </div>
          </div>
        </NavLink>

        {/* Navigation Actions Menu */}
        <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
          <NavLink to="/" className={getActiveClass} end onClick={closeMenu}>
            Home
          </NavLink>

          {/* Services Dropdown */}
          <div className="dropdown" ref={dropdownRef}>
            <span 
              className="nav-link dropdown-trigger" 
              style={{ cursor: "pointer" }}
              onClick={() => setShowServices(!showServices)}
            >
              Our Properties <span className="arrow-icon">▼</span>
            </span>

            {showServices && (
              <div className="services-dropdown-content">
                <NavLink
                  to="/Our_services"
                  className={getActiveClass}
                  onClick={closeMenu}
                >
                  For Rent
                </NavLink>

                <NavLink
                  to="/RentalLandingPage"
                  className={getActiveClass}
                  onClick={closeMenu}
                >
                  For Sale
                </NavLink>
              </div>
            )}
          </div>

          <NavLink to="/contact" className={getActiveClass} onClick={closeMenu}>
            Contact
          </NavLink>

          <NavLink to="/Login" className={getActiveClass} onClick={closeMenu}>
            Login
          </NavLink>

          {/* Smooth Theme Toggle Button */}
          <button className="theme-toggle" onClick={toggleTheme}>
            {theme === 'light' ? '🌙 Dark Mode' : '☀️ Light Mode'}
          </button>
        </div>

        {/* Hamburger Mobile Toggle */}
        <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

      </div>
    </nav>
  );
};

export default Navbar;